module.exports = __webpack_public_path__ + "static/media/harts_bg1.a586ff5d.jpg";